export const CHARGES_FILTER_CHARGEDBACK = {
  id: 'chargedback',
  text: 'charge.filter.chargeback'
}
